import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiService } from '../../services/api.service';
import * as DetectionLabelActions from './detection-label.actions';


@Injectable()
export class DetectionLabelsEffects {

  readonly loadDetectionLabels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DetectionLabelActions.loadDetectionLabels),
      exhaustMap(() =>
        this.api.detectionLabels$().pipe(
          map((labels) =>
            DetectionLabelActions.loadDetectionLabelsSuccess({
              labels,
            }),
          ),
          catchError((error: unknown) =>
            of(
              DetectionLabelActions.loadDetectionLabelsFailure({
                error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
  ) {}

}
